import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import renderHTML from 'react-render-html';
import { getExactResolutions } from '../../../utils/webp';
import { RTE } from '../../../utils/atoms';
import { desktop } from '../../../utils/breakpoints';
import { getWidth } from '../../../utils/adaptive';

import {
  Container, TileContents, TileHover, Front, ModalButton,
} from '../styles/profile-tile.style';

const defaultProps = {
  firstName: '',
  lastName: '',
  profilePicture: {
    file: {
      url: '',
      details: {
        image: {
          width: 0,
          height: 0,
        },
      },
    },
    resolutions: {
      base64: '',
    },
  },
  quote: {
    childMarkdownRemark: {
      html: '',
    },
  },
  title: '',
};

const propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  profilePicture: PropTypes.object,
  quote: PropTypes.object,
  title: PropTypes.string,
};

/**
 * Component that displays profile information for a single person
 * @param {object} props incoming props
 * @returns {XML} A profile tile
 */
class Tile extends React.Component {
  /**
   * constructor
   * @param {object} props Incoming Props
   */
  constructor(props) {
    super(props);
    this.ref = this.ref.bind(this);
    this.toggleActive = this.toggleActive.bind(this);
    this.state = {
      width: null,
      active: false,
      viewport: null,
    };
  }

  /**
   * Set viewport width on mount
   */
  componentDidMount() {
    this.setState({ viewport: getWidth() });
  }

  /**
   * Get rect
   * @param {object} element DOM reference
   */
  ref(element) {
    if (element && element.getBoundingClientRect) {
      this.setState({ width: element.getBoundingClientRect().width });
    }
  }

  /**
   * Toggle active state on mobile
   * @param {object} e event object
   */
  toggleActive(e) {
    const { active } = this.state;
    e.stopPropagation();
    this.setState({
      active: !active,
    });
  }

  /**
   * Render component
   * @returns {JSX} Component JSX
   */
  render() {
    const {
      firstName, lastName, profilePicture, quote, title, description, openModal,
    } = this.props;
    const { width, active, viewport } = this.state;
    let optimizedResolutions;
    if (profilePicture && width) {
      optimizedResolutions = getExactResolutions({
        image: profilePicture,
        width: Math.floor(Math.min(width, 1140)),
        height: 370,
        noCrop: true,
      });
    }
    let quoteExists = quote && quote.childMarkdownRemark && quote.childMarkdownRemark.html;
    if (quoteExists) {
      quoteExists = quote.childMarkdownRemark.html !== '';
    }
    const showButton = description && (active || viewport >= desktop.min);
    return (
      <Container onClick={e => this.toggleActive(e)}>
        <Front>
          <div ref={this.ref}>{optimizedResolutions ? <Img resolutions={optimizedResolutions} alt="" /> : ''}</div>
          {quoteExists && (
            <TileHover
              className={`xfl-profile__hover ${active ? 'xfl-profile__hover--active' : ''}`}
              onClick={e => this.toggleActive(e)}
            >
              {quote
                && quote.childMarkdownRemark && (
                <RTE className="xfl-profile__quote">{renderHTML(quote.childMarkdownRemark.html)}</RTE>
              )}
              { showButton && (
                <ModalButton onClick={e => openModal(`${firstName} ${lastName}`, description, e)}>
                  { 'Read More' }
                </ModalButton>
              ) }
            </TileHover>
          )}
        </Front>
        <TileContents>
          <h4>{`${firstName} ${lastName}`}</h4>
          <p>{title}</p>
        </TileContents>
      </Container>
    );
  }
}

Tile.defaultProps = defaultProps;
Tile.propTypes = propTypes;

export default Tile;



// WEBPACK FOOTER //
// ./src/components/profiles/components/profile-tile.js